import { render, staticRenderFns } from "./TableDialog.vue?vue&type=template&id=eebff3d8&"
import script from "./TableDialog.vue?vue&type=script&lang=ts&"
export * from "./TableDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TableDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports